export default "__VITE_ASSET__75d671c1__"